import React from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { sellersApi } from "../../api/sellers";
import DashboardLoadingState from "../dashboard/DashboardLoadingState";

const SellerContext = React.createContext(null);
export const useSeller = () => React.useContext(SellerContext);

export default function SellerRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const [access, setAccess] = React.useState(null);
  const [error, setError] = React.useState("");
  const [version, setVersion] = React.useState(0);
  React.useEffect(() => {
    let current = true;
    const load = () => sellersApi.profile().then((data) => { if (current) { setAccess(data.seller); setError(""); } })
      .catch((err) => { if (current) setError(err.message || "No pudimos validar tu acceso."); });
    load();
    window.addEventListener("focus", load);
    return () => { current = false; window.removeEventListener("focus", load); };
  }, [user?.id, location.pathname, version]);
  if (!access && !error) return <DashboardLoadingState fullPage label="Preparando tu espacio de vendedor…" />;
  if (error || !access?.active) return <Box sx={{ maxWidth: 680, mx: "auto", p: 3, pt: 8 }}>
    <Typography component="h1" variant="h4" fontWeight={900}>Panel de vendedores</Typography>
    <Alert severity={error ? "error" : "info"} sx={{ my: 3 }}>{error || (access?.status === "suspended" ? "Tu acceso de vendedor está suspendido." : "Tu cuenta todavía no está habilitada como vendedor.")}</Alert>
    <Typography color="text.secondary">El equipo de WebProfit administra la habilitación y las herramientas de tu cuenta.</Typography>
    <Stack direction="row" spacing={1} sx={{ mt: 3 }}><Button variant="contained" onClick={() => setVersion((v) => v + 1)}>Volver a validar</Button><Button component={Link} to="/dashboard">Volver a mis negocios</Button></Stack>
  </Box>;
  return <SellerContext.Provider value={access}>{children}</SellerContext.Provider>;
}
